/** Login, register, recover, MFA. Field labels live in ui/common.js. */
const dictionary = {
  "en": {
    "login": {
      "loginAsTalent": "Login as talent",
      "registerAsTalent": "Register as talent",
      "titleMobile": "Welcome to",
      "titleDesktop": "Welcome back to Apex Analytics Talent Management platform.",
      "subtitleMobile": "Sign in to find the best talents.",
      "subtitleDesktop": "Enter your details to enter Apex Analytics Talent Management platform.",
      "rememberMe": "Remember me",
      "recoverPassword": "Recover password",
      "signIn": "Log In",
      "signUp": "Register",
      "chromeRecommendBefore": "For the best user experience we recommend using ",
      "chromeRecommendAfter": " browser.",
      "downloadChrome": "download Chrome"
    },
    "register": {
      "stage1": {
        "titleMobile": "Welcome to",
        "titleDesktop": "Welcome to Apex Analytics Talent Management platform. Register to get started.",
        "subtitleMobile": "Fill your details to enter Apex Analytics Talent Management platform.",
        "subtitleDesktop": "Fill your details to enter Apex Analytics Talent Management platform.",
        "termsPrefix": "I agree with",
        "termsLink": "with terms and conditions",
        "signIn": "Login",
        "continue": "Continue Registration",
        "signUp": "Register"
      },
      "stage2": {
        "titleDesktop": "Enter your company details to proceed to Apex Analytics Corporate.",
        "subtitleMobile": "Fill in your company details and get good match from Apex Analytics Talent Pool.",
        "subtitleDesktop": "Fill in your company details and get good match from Apex Analytics Talent Pool.",
        "continue": "Continue Registration"
      },
      "stage3": {
        "titleDesktop": "Registration complete.",
        "subtitleMobile": "Registration complete.",
        "subtitleDesktop": "Now you can setup your pools and teams"
      },
      "pendingActivation": "Thank you for successfully registering your corporate account. We will contact you within 1-2 business day via phone or email for a demo and the activation of your account.",
      "contactUs": "Any questions? Contact us."
    },
    "recover": {
      "titleMobile": "Lost your password?",
      "titleDesktop": "Reset My Password",
      "subtitleMobile": "Enter your details to recover",
      "subtitleDesktop": "Reset password link will be sent to below entered email address",
      "backToLogin": "Back to login",
      "sendLink": "Send Reset Password Link"
    },
    "setPassword": {
      "title": "Set Your New Password"
    },
    "mfa": {
      "title": "Multi-factor Authentication",
      "titleHyphen": "Multi-Factor Authentication",
      "setupTitle": "Multi-factor Authentication Setup",
      "verificationTitle": "Multi-Factor Verification",
      "installationTitle": "Installation and Setup",
      "orgRequires": "Your organization requires multi-factor authentication for all users.",
      "clickToActivate": "Click below to activate Multi-Factor Authentication for added security.",
      "activateCta": "Activate Multi-Factor Authentication",
      "contactSupport": "Contact our support at security@apexteam.ai",
      "doNotClose": "Do not close or refresh this page until you have completed the setup.",
      "contactIfIssue": "If you have any issue, please contact our support at security@apexteam.ai",
      "installRecommend": "Please install a mobile authenticator app of your choice. We recommend:",
      "googleAuthenticatorFor": "Google Authenticator for",
      "microsoftAuthenticatorFor": "Microsoft Authenticator for",
      "authyAuthenticatorFor": "Authy Authenticator for",
      "android": "Android",
      "ios": "iOS",
      "or": "or",
      "openApp": "Open the app and look for an option similar to \"Set up an account\" or \"Scan a QR code\".",
      "holdPhone": "Hold your phone in front of the QR code below and scan it.",
      "doNotUseCameraPrefix": "Important: Do not",
      "doNotUseCameraRest": "use your phone’s camera app to scan the QR code.",
      "useAuthenticatorPrefix": "You must use the",
      "authenticatorApp": "Authenticator app",
      "useAuthenticatorRest": "to scan the code.",
      "willNotShowAgain": "For security reasons, we will not show these code again.",
      "saveQrLater": "If you need to leave, save the QR Code or Setup Key in a secure place, and complete the setup later.",
      "qrError": "There was an error generating QR code. Please try again later.",
      "enterSetupKey": "Or enter this Setup Key manually:",
      "doneSetup": "I have done the setup",
      "accountProtected": "Your account is protected with multi-factor authentication.",
      "enterCodeFromApp": "Please enter the code from your authenticator app.",
      "authCode": "Authentication code",
      "succeeded": "Verification succeeded!",
      "redirecting": "Redirecting to the dashboard in {seconds} seconds...",
      "backToSettings": "Back to Settings",
      "enforceCompany": "Enforce Multi-factor Authentication for all corporate accounts from your company",
      "toggleOwnAccount": "Activate / Deactivate Multi-factor Authentication for your own account",
      "companyRequires": "Your company requires Multi-factor Authentication (MFA) for all corporate users.",
      "cannotTurnOff": "As a result, MFA is already activated on your account and cannot be turned off.",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "confirmEnableCompanyNote": "Note: This will enforce Multi-factor Authentication (MFA) for all corporate users from your company.",
      "confirmEnableCompanyBody": "They must activate MFA for their own accounts, next time they login.",
      "confirmEnableCompanyAlready": "If they have already activated MFA, they will not be able to deactivate it.",
      "alreadyActivatedOwn": "You have already activated MFA for your own account. You don't have to do anything at this point.",
      "notYetActivatedOwn": "You have not yet activated MFA for your own account. You will be redirected to the MFA setup page.",
      "confirmDisableCompanyNote": "Note: This will disable Multi-factor Authentication (MFA) for all corporate users from your company.",
      "confirmDisableCompanyBody": "However, all corporate users (including your account) can still activate / deactivate MFA for their own accounts.",
      "confirmEnableUser": "Are you sure you want to activate Multi-factor Authentication for your account?",
      "confirmDisableUser": "Are you sure you want to deactivate Multi-factor Authentication for your account?",
      "qrCodeAlt": "QR Code",
      "errors": {
        "enforceCompany": "Error enforcing company MFA. Please try again later, or contact our support at security@apexteam.ai",
        "disableCompany": "Error disabling company MFA. Please try again later, or contact our support at security@apexteam.ai",
        "activateUser": "Error activating MFA for your account. Please try again later, or contact our support at security@apexteam.ai",
        "deactivateUser": "Error deactivating MFA for your account. Please try again later, or contact our support at security@apexteam.ai",
        "verify": "Error verifying MFA code. Please try again later, or contact our support at security@apexteam.ai"
      }
    }
  },
  "de": {
    "login": {
      "loginAsTalent": "Als Talent anmelden",
      "registerAsTalent": "Als Talent registrieren",
      "titleMobile": "Willkommen bei",
      "titleDesktop": "Willkommen zurück auf der Apex Analytics Talent Management Plattform.",
      "subtitleMobile": "Melden Sie sich an, um die besten Talente zu finden.",
      "subtitleDesktop": "Geben Sie Ihre Daten ein, um die Apex Analytics Talent Management Plattform zu nutzen.",
      "rememberMe": "Angemeldet bleiben",
      "recoverPassword": "Passwort wiederherstellen",
      "signIn": "Anmelden",
      "signUp": "Registrieren",
      "chromeRecommendBefore": "Für die beste Nutzererfahrung empfehlen wir den ",
      "chromeRecommendAfter": " Browser.",
      "downloadChrome": "Chrome herunterladen"
    },
    "register": {
      "stage1": {
        "titleMobile": "Willkommen bei",
        "titleDesktop": "Willkommen auf der Apex Analytics Talent Management Plattform. Registrieren Sie sich, um zu starten.",
        "subtitleMobile": "Füllen Sie Ihre Daten aus, um die Apex Analytics Talent Management Plattform zu nutzen.",
        "subtitleDesktop": "Füllen Sie Ihre Daten aus, um die Apex Analytics Talent Management Plattform zu nutzen.",
        "termsPrefix": "Ich stimme zu",
        "termsLink": "den Allgemeinen Geschäftsbedingungen",
        "signIn": "Anmelden",
        "continue": "Registrierung fortsetzen",
        "signUp": "Registrieren"
      },
      "stage2": {
        "titleDesktop": "Geben Sie Ihre Unternehmensdaten ein, um zu Apex Analytics Corporate zu gelangen.",
        "subtitleMobile": "Füllen Sie Ihre Unternehmensdaten aus und finden Sie passende Talente im Apex Analytics Talent Pool.",
        "subtitleDesktop": "Füllen Sie Ihre Unternehmensdaten aus und finden Sie passende Talente im Apex Analytics Talent Pool.",
        "continue": "Registrierung fortsetzen"
      },
      "stage3": {
        "titleDesktop": "Registrierung abgeschlossen.",
        "subtitleMobile": "Registrierung abgeschlossen.",
        "subtitleDesktop": "Jetzt können Sie Ihre Pools und Teams einrichten"
      },
      "pendingActivation": "Vielen Dank für die erfolgreiche Registrierung Ihres Unternehmenskontos. Wir kontaktieren Sie innerhalb von 1–2 Werktagen per Telefon oder E-Mail für eine Demo und die Aktivierung Ihres Kontos.",
      "contactUs": "Fragen? Kontaktieren Sie uns."
    },
    "recover": {
      "titleMobile": "Passwort vergessen?",
      "titleDesktop": "Mein Passwort zurücksetzen",
      "subtitleMobile": "Geben Sie Ihre Daten zur Wiederherstellung ein",
      "subtitleDesktop": "Der Link zum Zurücksetzen des Passworts wird an die unten angegebene E-Mail-Adresse gesendet",
      "backToLogin": "Zurück zur Anmeldung",
      "sendLink": "Link zum Zurücksetzen senden"
    },
    "setPassword": {
      "title": "Neues Passwort festlegen"
    },
    "mfa": {
      "title": "Multi-Faktor-Authentifizierung",
      "titleHyphen": "Multi-Faktor-Authentifizierung",
      "setupTitle": "Einrichtung der Multi-Faktor-Authentifizierung",
      "verificationTitle": "Multi-Faktor-Verifizierung",
      "installationTitle": "Installation und Einrichtung",
      "orgRequires": "Ihre Organisation verlangt die Multi-Faktor-Authentifizierung für alle Nutzer.",
      "clickToActivate": "Klicken Sie unten, um Multi-Faktor-Authentifizierung für zusätzliche Sicherheit zu aktivieren.",
      "activateCta": "Multi-Faktor-Authentifizierung aktivieren",
      "contactSupport": "Kontaktieren Sie unseren Support unter security@apexteam.ai",
      "doNotClose": "Schließen oder aktualisieren Sie diese Seite nicht, bis die Einrichtung abgeschlossen ist.",
      "contactIfIssue": "Bei Problemen kontaktieren Sie unseren Support unter security@apexteam.ai",
      "installRecommend": "Bitte installieren Sie eine Authenticator-App Ihrer Wahl. Wir empfehlen:",
      "googleAuthenticatorFor": "Google Authenticator für",
      "microsoftAuthenticatorFor": "Microsoft Authenticator für",
      "authyAuthenticatorFor": "Authy Authenticator für",
      "android": "Android",
      "ios": "iOS",
      "or": "oder",
      "openApp": "Öffnen Sie die App und suchen Sie eine Option wie „Konto einrichten“ oder „QR-Code scannen“.",
      "holdPhone": "Halten Sie Ihr Telefon vor den QR-Code unten und scannen Sie ihn.",
      "doNotUseCameraPrefix": "Wichtig: Verwenden Sie nicht",
      "doNotUseCameraRest": "die Kamera-App Ihres Telefons, um den QR-Code zu scannen.",
      "useAuthenticatorPrefix": "Sie müssen die",
      "authenticatorApp": "Authenticator-App",
      "useAuthenticatorRest": "verwenden, um den Code zu scannen.",
      "willNotShowAgain": "Aus Sicherheitsgründen zeigen wir diesen Code nicht erneut.",
      "saveQrLater": "Wenn Sie die Seite verlassen müssen, speichern Sie den QR-Code oder den Setup-Schlüssel an einem sicheren Ort und schließen Sie die Einrichtung später ab.",
      "qrError": "Beim Erzeugen des QR-Codes ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      "enterSetupKey": "Oder geben Sie diesen Setup-Schlüssel manuell ein:",
      "doneSetup": "Ich habe die Einrichtung abgeschlossen",
      "accountProtected": "Ihr Konto ist durch Multi-Faktor-Authentifizierung geschützt.",
      "enterCodeFromApp": "Bitte geben Sie den Code aus Ihrer Authenticator-App ein.",
      "authCode": "Authentifizierungscode",
      "succeeded": "Verifizierung erfolgreich!",
      "redirecting": "Weiterleitung zum Dashboard in {seconds} Sekunden...",
      "backToSettings": "Zurück zu den Einstellungen",
      "enforceCompany": "Multi-Faktor-Authentifizierung für alle Unternehmenskonten Ihrer Firma erzwingen",
      "toggleOwnAccount": "Multi-Faktor-Authentifizierung für Ihr eigenes Konto aktivieren / deaktivieren",
      "companyRequires": "Ihr Unternehmen verlangt Multi-Faktor-Authentifizierung (MFA) für alle Unternehmensnutzer.",
      "cannotTurnOff": "Daher ist MFA auf Ihrem Konto bereits aktiviert und kann nicht deaktiviert werden.",
      "deactivate": "Deaktivieren",
      "activate": "Aktivieren",
      "confirmEnableCompanyNote": "Hinweis: Dadurch wird Multi-Faktor-Authentifizierung (MFA) für alle Unternehmensnutzer Ihrer Firma erzwungen.",
      "confirmEnableCompanyBody": "Sie müssen MFA für ihre eigenen Konten aktivieren, wenn sie sich das nächste Mal anmelden.",
      "confirmEnableCompanyAlready": "Wenn sie MFA bereits aktiviert haben, können sie sie nicht mehr deaktivieren.",
      "alreadyActivatedOwn": "Sie haben MFA für Ihr eigenes Konto bereits aktiviert. Sie müssen derzeit nichts weiter tun.",
      "notYetActivatedOwn": "Sie haben MFA für Ihr eigenes Konto noch nicht aktiviert. Sie werden zur MFA-Einrichtungsseite weitergeleitet.",
      "confirmDisableCompanyNote": "Hinweis: Dadurch wird Multi-Faktor-Authentifizierung (MFA) für alle Unternehmensnutzer Ihrer Firma deaktiviert.",
      "confirmDisableCompanyBody": "Alle Unternehmensnutzer (einschließlich Ihres Kontos) können MFA für ihre eigenen Konten weiterhin aktivieren / deaktivieren.",
      "confirmEnableUser": "Möchten Sie die Multi-Faktor-Authentifizierung für Ihr Konto wirklich aktivieren?",
      "confirmDisableUser": "Möchten Sie die Multi-Faktor-Authentifizierung für Ihr Konto wirklich deaktivieren?",
      "qrCodeAlt": "QR-Code",
      "errors": {
        "enforceCompany": "Fehler beim Erzwingen der Unternehmens-MFA. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support unter security@apexteam.ai",
        "disableCompany": "Fehler beim Deaktivieren der Unternehmens-MFA. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support unter security@apexteam.ai",
        "activateUser": "Fehler beim Aktivieren der MFA für Ihr Konto. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support unter security@apexteam.ai",
        "deactivateUser": "Fehler beim Deaktivieren der MFA für Ihr Konto. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support unter security@apexteam.ai",
        "verify": "Fehler beim Prüfen des MFA-Codes. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support unter security@apexteam.ai"
      }
    }
  },
  "fi": {
    "login": {
      "loginAsTalent": "Kirjaudu osaajana",
      "registerAsTalent": "Rekisteröidy osaajana",
      "titleMobile": "Tervetuloa",
      "titleDesktop": "Tervetuloa takaisin Apex Analytics Talent Management -alustalle.",
      "subtitleMobile": "Kirjaudu sisään ja löydä parhaat osaajat.",
      "subtitleDesktop": "Kirjaudu Apex Analytics Talent Management -alustalle antamalla tietosi.",
      "rememberMe": "Muista minut",
      "recoverPassword": "Palauta salasana",
      "signIn": "Kirjaudu sisään",
      "signUp": "Rekisteröidy",
      "chromeRecommendBefore": "Parhaan käyttökokemuksen saat ",
      "chromeRecommendAfter": "-selaimella.",
      "downloadChrome": "lataa Chrome"
    },
    "register": {
      "stage1": {
        "titleMobile": "Tervetuloa",
        "titleDesktop": "Tervetuloa Apex Analytics Talent Management -alustalle. Aloita rekisteröitymällä.",
        "subtitleMobile": "Täytä tietosi, niin pääset Apex Analytics Talent Management -alustalle.",
        "subtitleDesktop": "Täytä tietosi, niin pääset Apex Analytics Talent Management -alustalle.",
        "termsPrefix": "Hyväksyn",
        "termsLink": "käyttöehdot",
        "signIn": "Kirjaudu sisään",
        "continue": "Jatka rekisteröintiä",
        "signUp": "Rekisteröidy"
      },
      "stage2": {
        "titleDesktop": "Jatka Apex Analytics Corporateen antamalla yrityksesi tiedot.",
        "subtitleMobile": "Täytä yrityksesi tiedot ja löydä sopiva osaaja Apex Analytics Talent Poolista.",
        "subtitleDesktop": "Täytä yrityksesi tiedot ja löydä sopiva osaaja Apex Analytics Talent Poolista.",
        "continue": "Jatka rekisteröintiä"
      },
      "stage3": {
        "titleDesktop": "Rekisteröinti valmis.",
        "subtitleMobile": "Rekisteröinti valmis.",
        "subtitleDesktop": "Nyt voit luoda poolit ja tiimit"
      },
      "pendingActivation": "Kiitos yritystilin rekisteröinnistä. Otamme sinuun yhteyttä 1–2 työpäivän kuluessa puhelimitse tai sähköpostitse sopiaksemme esittelystä ja aktivoidaksemme tilisi.",
      "contactUs": "Kysyttävää? Ota yhteyttä."
    },
    "recover": {
      "titleMobile": "Unohditko salasanasi?",
      "titleDesktop": "Palauta salasana",
      "subtitleMobile": "Anna tietosi palauttaaksesi",
      "subtitleDesktop": "Salasanan palautuslinkki lähetetään alla antamaasi sähköpostiosoitteeseen",
      "backToLogin": "Takaisin kirjautumiseen",
      "sendLink": "Lähetä salasanan palautuslinkki"
    },
    "setPassword": {
      "title": "Aseta uusi salasanasi"
    },
    "mfa": {
      "title": "Monivaiheinen tunnistautuminen",
      "titleHyphen": "Monivaiheinen tunnistautuminen",
      "setupTitle": "Monivaiheisen tunnistautumisen käyttöönotto",
      "verificationTitle": "Monivaiheinen varmennus",
      "installationTitle": "Asennus ja määritys",
      "orgRequires": "Organisaatiosi vaatii monivaiheisen tunnistautumisen kaikilta käyttäjiltä.",
      "clickToActivate": "Ota monivaiheinen tunnistautuminen käyttöön lisäturvaksi napsauttamalla alla olevaa painiketta.",
      "activateCta": "Ota monivaiheinen tunnistautuminen käyttöön",
      "contactSupport": "Ota yhteyttä tukeemme: security@apexteam.ai",
      "doNotClose": "Älä sulje tai päivitä tätä sivua, ennen kuin olet viimeistellyt käyttöönoton.",
      "contactIfIssue": "Jos kohtaat ongelmia, ota yhteyttä tukeemme: security@apexteam.ai",
      "installRecommend": "Asenna puhelimeesi haluamasi tunnistautumissovellus. Suosittelemme:",
      "googleAuthenticatorFor": "Google Authenticator",
      "microsoftAuthenticatorFor": "Microsoft Authenticator",
      "authyAuthenticatorFor": "Authy Authenticator",
      "android": "Android",
      "ios": "iOS",
      "or": "tai",
      "openApp": "Avaa sovellus ja etsi vaihtoehto, jonka nimi on esimerkiksi \"Lisää tili\" tai \"Skannaa QR-koodi\".",
      "holdPhone": "Skannaa alla oleva QR-koodi puhelimellasi.",
      "doNotUseCameraPrefix": "Tärkeää: Älä",
      "doNotUseCameraRest": "käytä puhelimesi kameraa QR-koodin skannaamiseen.",
      "useAuthenticatorPrefix": "Sinun on käytettävä",
      "authenticatorApp": "Authenticator-sovellusta",
      "useAuthenticatorRest": "koodin skannaamiseen.",
      "willNotShowAgain": "Turvallisuussyistä emme näytä tätä koodia uudelleen.",
      "saveQrLater": "Jos sinun täytyy poistua, tallenna QR-koodi tai asetusavain turvalliseen paikkaan ja viimeistele käyttöönotto myöhemmin.",
      "qrError": "QR-koodin luomisessa tapahtui virhe. Yritä uudelleen myöhemmin.",
      "enterSetupKey": "Tai syötä tämä asetusavain manuaalisesti:",
      "doneSetup": "Käyttöönotto on tehty",
      "accountProtected": "Tilisi on suojattu monivaiheisella tunnistautumisella.",
      "enterCodeFromApp": "Anna todennussovelluksesi koodi.",
      "authCode": "Todennuskoodi",
      "succeeded": "Vahvistus onnistui!",
      "redirecting": "Siirrytään etusivulle {seconds} sekunnin kuluttua...",
      "backToSettings": "Takaisin asetuksiin",
      "enforceCompany": "Vaadi monivaiheista tunnistautumista kaikilta yrityksesi käyttäjätileiltä",
      "toggleOwnAccount": "Ota monivaiheinen tunnistautuminen käyttöön tai poista se käytöstä omalla tililläsi",
      "companyRequires": "Yrityksesi vaatii monivaiheisen tunnistautumisen (MFA) kaikille yrityskäyttäjille.",
      "cannotTurnOff": "Tämän vuoksi MFA on jo otettu käyttöön tililläsi, eikä sitä voi poistaa käytöstä.",
      "deactivate": "Poista käytöstä",
      "activate": "Ota käyttöön",
      "confirmEnableCompanyNote": "Huom: Tämä tekee monivaiheisesta tunnistautumisesta (MFA) pakollisen kaikille yrityksesi käyttäjille.",
      "confirmEnableCompanyBody": "Heidän on otettava MFA käyttöön omalla tilillään, kun he kirjautuvat seuraavan kerran.",
      "confirmEnableCompanyAlready": "Jos he ovat jo ottaneet monivaiheisen tunnistautumisen (MFA) käyttöön, he eivät voi poistaa sitä käytöstä.",
      "alreadyActivatedOwn": "Olet jo ottanut monivaiheisen tunnistautumisen (MFA) käyttöön omalle tilillesi. Sinun ei tarvitse tehdä mitään tässä vaiheessa.",
      "notYetActivatedOwn": "Et ole vielä ottanut monivaiheista tunnistautumista (MFA) käyttöön omalle tilillesi. Sinut ohjataan MFA-asetussivulle.",
      "confirmDisableCompanyNote": "Huom: Tämä poistaa monivaiheisen tunnistautumisen (MFA) käytöstä kaikilta yrityksesi käyttäjiltä.",
      "confirmDisableCompanyBody": "Kaikki yrityskäyttäjät (mukaan lukien tilisi) voivat kuitenkin edelleen ottaa MFA:n käyttöön tai poistaa sen käytöstä omilla tileillään.",
      "confirmEnableUser": "Haluatko varmasti ottaa monivaiheisen tunnistautumisen käyttöön tililläsi?",
      "confirmDisableUser": "Haluatko varmasti poistaa monivaiheisen tunnistautumisen käytöstä tililläsi?",
      "qrCodeAlt": "QR-koodi",
      "errors": {
        "enforceCompany": "Virhe yrityksen MFA-vaatimuksen käyttöönotossa. Yritä myöhemmin uudelleen tai ota yhteyttä tukeemme: security@apexteam.ai",
        "disableCompany": "Virhe yrityksen MFA-vaatimuksen poistamisessa. Yritä myöhemmin uudelleen tai ota yhteyttä tukeemme: security@apexteam.ai",
        "activateUser": "Virhe MFA:n käyttöönotossa tililläsi. Yritä myöhemmin uudelleen tai ota yhteyttä tukeemme: security@apexteam.ai",
        "deactivateUser": "Virhe MFA:n poistamisessa käytöstä tililläsi. Yritä myöhemmin uudelleen tai ota yhteyttä tukeemme: security@apexteam.ai",
        "verify": "Virhe MFA-koodin vahvistamisessa. Yritä myöhemmin uudelleen tai ota yhteyttä tukeemme: security@apexteam.ai"
      }
    }
  }
};

export default dictionary;
